module.exports = __webpack_public_path__ + "img/card-service-purchase-request-hover.27c8727b.svg";